// extracted by mini-css-extract-plugin
module.exports = {"link_download":"DownloadWhale_link_download_3gwOY","mo":"DownloadWhale_mo_3RKE8","pc":"DownloadWhale_pc_3oZYD","text":"DownloadWhale_text_V0ZDg"};